import { BaseConditionData } from './base-condition-data';
import { WorkflowConditionTypes } from './Enums/workflow-condition-types';

/**
 * Représente les données d'une condition 'Une étape donnée doit être dans un état spécifique'.
 */
export class StepSpecificStateConditionData extends BaseConditionData {
    /**
     * Identifiant de l'étape.
     */
    public stepId: number = null;

    /**
     * Identifiant de l'état que l'étape doit avoir.
     */
    public stateId: number = null;

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowConditionTypes.StepSpecificState);
    }

    /**
     * Retourne une copie d'une instance de StepSpecificStateConditionData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: StepSpecificStateConditionData) {
        if (!!other) {
            const instance = new StepSpecificStateConditionData();
            instance.stepId = other.stepId;
            instance.stateId = other.stateId;
            instance.name = other.name;
            instance.type = other.type;
            instance.id = other.id;
            instance.isMainCondition = other.isMainCondition;

            return instance;
        } else {
            return null;
        }
    }
}
